import { Outlet } from "react-router-dom";


const MainApp = () => {
  return (
    <>
     
        <Outlet />
    </>
  );
};

export default MainApp;
